<script>
    import {router,} from 'tinro';

    let params = router.params();

    let host = window.location.host;
    let url = `//${host}:18000/#/home/project/${params.project.replace(/ /g,'%20')}`;

    
</script>

<iframe src="{url}" width="100%" height="100%" align="left" title="ide">
    Ваш браузер не поддерживает плавающие фреймы!
</iframe>